module.exports = __webpack_public_path__ + "img/pexels-steve-johnson-1606591.15c3eab0.jpg";